module.exports = __webpack_public_path__ + "img/formationBackground.8583314f.jpg";